import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environment/environment';
import { CateringGroupDTO } from '../../../dto/catering/catering-group.dto';

@Component({
  selector: 'app-duna-catering-groups-edit-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  template: `
    <h2 mat-dialog-title>Rediger forplejningsgruppe</h2>
    <mat-dialog-content>
      <form [formGroup]="form" class="form">
        <mat-form-field appearance="outline">
          <mat-label>Navn *</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Beskrivelse</mat-label>
          <textarea matInput formControlName="description" rows="3"></textarea>
        </mat-form-field>
        @if (error) {
        <p class="error">{{ error }}</p>
        }
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="dialogRef.close(false)">
        Annuller
      </button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="form.invalid || isSubmitting"
        (click)="onSave()"
      >
        Gem
      </button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .form {
        display: flex;
        flex-direction: column;
        min-width: 420px;
        padding-top: 8px;
      }
      mat-form-field {
        width: 100%;
      }
      .error {
        color: #f44336;
      }
    `,
  ],
})
export class DunaCateringGroupsEditDialogComponent {
  form: FormGroup;
  isSubmitting = false;
  error: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<DunaCateringGroupsEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { group: CateringGroupDTO },
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.form = this.fb.group({
      name: [data.group.name, Validators.required],
      description: [data.group.description || ''],
    });
  }

  onSave(): void {
    if (this.form.invalid || this.isSubmitting) return;
    this.isSubmitting = true;
    this.http
      .patch(
        `${environment.apiUrl}/events/catering/groups/${this.data.group.catering_group_id}`,
        {
          name: this.form.value.name.trim(),
          description: this.form.value.description?.trim() || null,
        }
      )
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: (err) => {
          this.isSubmitting = false;
          this.error = err?.error?.message || 'Der opstod en fejl.';
        },
      });
  }
}
